import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=b4a6ae36&scoped=true&"
import script from "./ProductLinks.vue?vue&type=script&lang=js&"
export * from "./ProductLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProductLinks.vue?vue&type=style&index=0&id=b4a6ae36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a6ae36",
  null
  
)

export default component.exports